module.exports = __webpack_public_path__ + "static/d6061ed918bf8c4d25a3d8f798a5a00e0baef9357df288854e0be17783d5f4dd-bc26872e1879e7832684a2f9f98174da.jpeg";